import React from 'react';

const AppContext = React.createContext(undefined);

export default AppContext;
